var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDestinos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#020C41;stroke-width:1.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -3.6817 45.6726)",
    className: "st0",
    cx: 25,
    cy: 25,
    rx: 19.7,
    ry: 19.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,5.3c5.4,0,9.9,8.8,9.9,19.7c0,10.9-4.4,19.7-9.9,19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.9,5.3c-5.4,0-9.8,8.8-9.8,19.7c0,10.9,4.4,19.7,9.8,19.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.3,
    y1: 5.3,
    x2: 24.3,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 44.7,
    y1: 25.8,
    x2: 5.3,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 43.2,
    y1: 17.4,
    x2: 6.8,
    y2: 17.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 42.5,
    y1: 34,
    x2: 7.5,
    y2: 34
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinos);
export default __webpack_public_path__ + "static/media/destinos.626fa4b28c559b8c4c2d8ff17fd6a482.svg";
export { ForwardRef as ReactComponent };